/* Bundle Landing Page Scripts - assets/bundle-lp.js */
(function() {
  'use strict';
  var CONFIG = window.BLP_CONFIG || {};

  /* HARDCODED gift-per-tier mapping.
     This overrides the data-blp-gifts attribute from the theme editor
     so it works regardless of theme settings. */
  var GIFTS_PER_TIER = { 4: 4, 3: 3, 2: 2, 1: 1 };

  var state = { qty: 4, discount: '67', gifts: 4 };

  /* DEBUG */
  console.log('[BLP] CONFIG:', JSON.stringify(CONFIG));

  /* COUNTDOWN */
  function updateClock() {
    var now = new Date();
    var etHour = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }));
    var target;
    if (etHour < 13) {
      var today = now.toLocaleDateString('sv-SE', { timeZone: 'America/New_York' });
      var tz = Intl.DateTimeFormat('en', { timeZone: 'America/New_York', timeZoneName: 'short' }).formatToParts(now).find(function(p) { return p.type === 'timeZoneName'; }).value;
      target = new Date(today + 'T13:00:00' + (tz === 'EST' ? '-05:00' : '-04:00'));
    } else {
      target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    }
    var diff = Math.max(0, target - now);
    var pad = function(n) { return String(n).padStart(2, '0'); };
    var el = function(s) { return document.querySelector(s); };
    if (el('[data-blp-clock="h"]')) el('[data-blp-clock="h"]').textContent = pad(Math.floor(diff / 3600000));
    if (el('[data-blp-clock="m"]')) el('[data-blp-clock="m"]').textContent = pad(Math.floor((diff % 3600000) / 60000));
    if (el('[data-blp-clock="s"]')) el('[data-blp-clock="s"]').textContent = pad(Math.floor((diff % 60000) / 1000));
  }
  updateClock(); setInterval(updateClock, 1000);

  /* ORDER BY TIME */
  (function() {
    var now = new Date();
    var etHour = parseInt(now.toLocaleString('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false }));
    var text = etHour < 13 ? '1:00 PM ET Today' : 'Tomorrow';
    document.querySelectorAll('[data-blp-orderby]').forEach(function(el) { el.textContent = text; });
  })();

  /* TOPBAR SCROLL */
  var topbar = document.getElementById('blp-topbar');
  var scrollTarget = document.getElementById('blp-scroll-target');
  if (topbar && scrollTarget) {
    topbar.addEventListener('click', function() { if (window.innerWidth < 1024) scrollTarget.scrollIntoView({ behavior: 'smooth' }); });
  }

  /* CAROUSEL */
  var thumbs = document.querySelectorAll('[data-blp-slide]');
  var mainImg = document.getElementById('blp-carousel-main');
  var currentSlide = 0;
  function goToSlide(i) {
    if (!thumbs.length || i < 0 || i >= thumbs.length) return;
    currentSlide = i;
    var t = thumbs[i];
    if (mainImg && t) { mainImg.src = t.getAttribute('data-blp-slide'); mainImg.alt = t.getAttribute('data-blp-alt') || ''; }
    thumbs.forEach(function(th, idx) { th.classList.toggle('blp-carousel__thumb--active', idx === i); });
  }
  var nb = document.getElementById('blp-carousel-next');
  var pb = document.getElementById('blp-carousel-prev');
  if (nb) nb.addEventListener('click', function() { goToSlide((currentSlide + 1) % thumbs.length); });
  if (pb) pb.addEventListener('click', function() { goToSlide((currentSlide - 1 + thumbs.length) % thumbs.length); });
  thumbs.forEach(function(t, i) { t.addEventListener('click', function() { goToSlide(i); }); });
  var car = document.getElementById('blp-carousel');
  var sx = 0;
  if (car) {
    car.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; });
    car.addEventListener('touchend', function(e) {
      var d = e.changedTouches[0].clientX - sx;
      if (d > 50) goToSlide((currentSlide - 1 + thumbs.length) % thumbs.length);
      else if (d < -50) goToSlide((currentSlide + 1) % thumbs.length);
    });
  }

  /* QTY SELECTOR + GIFT UNLOCK */
  var qtyCards = document.querySelectorAll('.blp-qty__card:not(.blp-qty__card--oos)');
  var giftCards = document.querySelectorAll('[data-blp-gift-unlock]');

  /* Force correct unlock_at on each gift card by index (1-based).
     This overrides whatever the theme editor has set. */
  giftCards.forEach(function(g, i) {
    g.setAttribute('data-blp-gift-unlock', i + 1);
    console.log('[BLP] Gift #' + (i + 1) + ': forced unlock_at=' + (i + 1));
  });

  function selectQty(card) {
    document.querySelectorAll('.blp-qty__card').forEach(function(c) { c.classList.remove('blp-qty__card--active'); });
    card.classList.add('blp-qty__card--active');
    state.qty = parseInt(card.getAttribute('data-blp-qty'));
    state.discount = card.getAttribute('data-blp-discount') || '0';

    /* Use hardcoded mapping instead of data attribute */
    state.gifts = GIFTS_PER_TIER[state.qty] || state.qty;

    console.log('[BLP] selectQty: qty=' + state.qty + ' gifts=' + state.gifts + ' discount=' + state.discount);

    var dd = document.getElementById('blp-discount-display');
    if (dd) dd.textContent = state.discount;
    ['blp-gift-count', 'blp-gift-count-sticky'].forEach(function(id) {
      var e = document.getElementById(id);
      if (e) e.textContent = state.gifts;
    });

    giftCards.forEach(function(g, i) {
      var unlock = parseInt(g.getAttribute('data-blp-gift-unlock'));
      var locked = state.gifts < unlock;
      console.log('[BLP] Gift #' + (i + 1) + ': unlock_at=' + unlock + ' state.gifts=' + state.gifts + ' locked=' + locked);
      g.classList.toggle('blp-gift--locked', locked);
    });

    var overrideTotal = card.getAttribute('data-blp-total-price');
    var totalPrice = overrideTotal ? parseFloat(overrideTotal).toFixed(2) : (parseFloat(card.getAttribute('data-blp-price-each')) * parseInt(card.getAttribute('data-blp-qty'))).toFixed(2);
    var ctaPriceEl = document.getElementById('blp-cta-price');
    if (ctaPriceEl) ctaPriceEl.textContent = '- $' + totalPrice;
  }

  qtyCards.forEach(function(c) { c.addEventListener('click', function() { selectQty(c); }); });

  /* On initial load, find the active card and run selectQty.
     Default to 4-pack (first card) if none is active. */
  var dc = document.querySelector('.blp-qty__card--active');
  if (!dc) dc = document.querySelector('.blp-qty__card');
  if (dc) selectQty(dc);

  /* ADD TO CART / STEP 2 REDIRECT */
  function addToCart() {
    console.log('[BLP] addToCart called. useStep2Flow=' + CONFIG.useStep2Flow + ' step2BaseUrl="' + CONFIG.step2BaseUrl + '"');

    /* Step 2 redirect */
    if (CONFIG.useStep2Flow && CONFIG.step2BaseUrl) {
      var url = CONFIG.step2BaseUrl + '?handle=' + encodeURIComponent(CONFIG.productHandle) + '&cartridges=' + state.qty + '&gifts=' + state.gifts + '&discount=' + encodeURIComponent(state.discount) + '&selling_plan=' + (CONFIG.sellingPlanId || '');
      console.log('[BLP] Redirecting to step 2: ' + url);
      window.location.href = url;
      return;
    }

    console.log('[BLP] Step 2 flow NOT active, adding to cart instead.');
    var btn = document.getElementById('blp-main-cta');
    var txt = document.getElementById('blp-cta-text');
    if (btn) btn.classList.add('blp-cta--loading');
    if (txt) txt.textContent = 'Adding...';
    var tierData = CONFIG.tiers && CONFIG.tiers[state.qty] ? CONFIG.tiers[state.qty] : { qty: state.qty };
    var cartQty = tierData.qty || state.qty;
    var items = [];
    var main = { id: parseInt(CONFIG.variantId), quantity: cartQty };
    if (CONFIG.sellingPlanId) main.selling_plan = parseInt(CONFIG.sellingPlanId);
    items.push(main);
    if (CONFIG.giftVariants) {
      for (var gl = 1; gl <= state.gifts; gl++) { var gv = CONFIG.giftVariants[gl]; if (gv) items.push({ id: parseInt(gv), quantity: 1 }); }
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(r) { if (!r.ok) throw new Error('Failed'); return r.json(); })
    .then(function() { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { offerType: 'bundle-lp', discountType: state.discount, sticksSelected: String(cartQty) } }) }); })
    .then(function() { window.location.href = CONFIG.cartRedirect || '/cart'; })
    .catch(function(err) { console.error(err); if (btn) btn.classList.remove('blp-cta--loading'); if (txt) txt.textContent = 'Add to Cart'; alert('Something went wrong. Please try again.'); });
  }

  var mc = document.getElementById('blp-main-cta');
  var sc = document.getElementById('blp-sticky-cta');
  if (mc) mc.addEventListener('click', function(e) { e.preventDefault(); addToCart(); });
  if (sc) sc.addEventListener('click', function(e) { e.preventDefault(); addToCart(); });

  /* FAQ */
  document.querySelectorAll('.blp-faq__q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement, ans = btn.nextElementSibling, open = item.classList.contains('blp-faq__item--open');
      document.querySelectorAll('.blp-faq__item').forEach(function(fi) { fi.classList.remove('blp-faq__item--open'); var a = fi.querySelector('.blp-faq__a'); if (a) a.style.maxHeight = null; });
      if (!open) { item.classList.add('blp-faq__item--open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
    });
  });

  /* STICKY CTA */
  var sEl = document.getElementById('blp-sticky');
  var fEl = document.getElementById('blp-product-form');
  var sv = false;
  function chk() { if (!fEl || !sEl) return; var r = fEl.getBoundingClientRect(); var s = r.bottom < 0; if (s !== sv) { sv = s; sEl.classList.toggle('blp-sticky--visible', s); } }
  window.addEventListener('scroll', chk, { passive: true }); chk();
  /* HOME SIZE SWAP */
  var hsCards = document.querySelectorAll('[data-homesize-idx]');
  hsCards.forEach(function(card) {
    card.addEventListener('click', function() {
      hsCards.forEach(function(c) { c.classList.remove('blp-homesize__card--active'); c.style.borderColor = '#ddd'; });
      card.classList.add('blp-homesize__card--active');
      card.style.borderColor = '#1aac80';

      CONFIG.variantId = parseInt(card.getAttribute('data-hs-variant'));
      CONFIG.sellingPlanId = parseInt(card.getAttribute('data-hs-plan')) || null;
      CONFIG.productHandle = card.getAttribute('data-hs-handle');
      var urgencyText = card.getAttribute('data-hs-urgency');
      if (urgencyText) { var ue = document.getElementById('blp-urgency-text'); if (ue) ue.textContent = urgencyText; }

      document.querySelectorAll('.blp-qty__card').forEach(function(tc) {
        var q = tc.getAttribute('data-blp-qty');
        var p = card.getAttribute('data-hs-p' + q);
        var cp = card.getAttribute('data-hs-cp' + q);
        var tp = card.getAttribute('data-hs-tp' + q);
        if (p) {
          tc.setAttribute('data-blp-price-each', p);
          var pe = tc.querySelector('.blp-qty__price');
          if (pe) { pe.innerHTML = (cp ? '<span style="text-decoration:line-through;color:#999;margin-right:4px;">$' + cp + '</span>' : '') + '$' + p + '/each'; }
        }
        if (tp) { tc.setAttribute('data-blp-total-price', tp); } else { tc.removeAttribute('data-blp-total-price'); }
      });

      var imgs = card.getAttribute('data-hs-imgs').split('|').filter(Boolean);
      var thmbs = card.getAttribute('data-hs-thumbs').split('|').filter(Boolean);
      if (imgs.length) {
        if (mainImg) mainImg.src = imgs[0];
        thumbs.forEach(function(td, i) {
          if (imgs[i]) { td.setAttribute('data-blp-slide', imgs[i]); var ti = td.querySelector('img'); if (ti && thmbs[i]) ti.src = thmbs[i]; td.style.display = ''; }
          else { td.style.display = 'none'; }
          td.classList.toggle('blp-carousel__thumb--active', i === 0);
        });
      }

      var aq = document.querySelector('.blp-qty__card--active:not(.blp-qty__card--oos)');
      if (aq) aq.click();
    });
  });
})();
